import { useQuery, useMutation } from "react-query";
import {
	get_help_topics_api,
	add_help_topic_api,
	update_help_topic_api,
	delete_help_topic_api,
	get_help_queries_api,
	delete_help_query_api,
	update_help_query_api,
} from "../services/help";

export const useGetHelpTopics = (payload) =>
	useQuery(["getHelpTopic", payload], () => get_help_topics_api(payload));

export const useAddHelpTopic = () =>
	useMutation("addHelpTopic", (body) => add_help_topic_api(body));

export const useUpdateHelpTopic = () =>
	useMutation("updateHelpTopic", (body) => update_help_topic_api(body));

export const useDeleteHelpTopic = () =>
	useMutation("deleteHelpTopic", (body) => delete_help_topic_api(body));

export const useGetHelpQueries = (payload) =>
	useQuery(["getHelpQueries", payload], () => get_help_queries_api(payload));

export const useDeleteHelpQuery = () =>
	useMutation("deleteHelpQuery", (body) => delete_help_query_api(body));

export const useUpdateHelpQuery = () =>
	useMutation("updateHelpTopic", (body) => update_help_query_api(body));
